import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CATEGORIES = ['Parking', 'Tolls', 'Fuel'];

export const ReceiptEditDialog = ({ receipt, onClose, onSaved }) => {
  const [form, setForm] = useState({ category: 'Parking', amount: '', note: '', bookingId: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (receipt) setForm({ category: receipt.category, amount: String(receipt.amount ?? ''), note: receipt.note || '', bookingId: receipt.bookingId || '' });
  }, [receipt]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    const amount = parseFloat(form.amount);
    if (!(amount > 0)) return toast.error('Amount must be greater than £0');
    setSaving(true);
    try {
      const res = await axios.patch(`${API}/admin/receipts/${receipt.id}`, { ...form, amount, bookingId: form.bookingId.trim() || null });
      toast.success('Receipt updated');
      onSaved(res.data.receipt);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to update receipt');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!receipt} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="receipt-edit-dialog">
        <DialogHeader><DialogTitle>Correct receipt {receipt?.id}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Type</Label>
            <select value={form.category} onChange={set('category')} className="mt-1 h-10 w-full rounded-md border border-gray-300 px-2 text-sm bg-white" data-testid="receipt-edit-category">
              {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <Label>Amount (£)</Label>
            <Input type="number" step="0.01" min="0.01" value={form.amount} onChange={set('amount')} className="mt-1" data-testid="receipt-edit-amount" />
          </div>
          <div>
            <Label>Linked booking</Label>
            <Input value={form.bookingId} onChange={set('bookingId')} placeholder="e.g. OC-1A2B3C4D5E6F (leave blank for none)" className="mt-1" data-testid="receipt-edit-booking" />
          </div>
          <div>
            <Label>Note</Label>
            <Textarea value={form.note} onChange={set('note')} rows={2} className="mt-1" data-testid="receipt-edit-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="receipt-edit-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving} className="bg-black text-white hover:bg-gray-800" data-testid="receipt-edit-save">
            {saving ? 'Saving…' : 'Save changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
